@for (section of sections; track section) {
  <div
    [ngClass]="getSectionClass(section)"
    ng-form
    name="section">
    @if (section?.sections?.length > 0) {
      <estimate-section [estimate]="estimate"
        [sections]="section.sections"
      [estimateChange]="estimateChange"></estimate-section>
    }
    <div [@hasError]="hasError(section) ? 'error' : 'valid'"
      [ngClass]="getItemGroupClass(section)">
      @for (item of section?.items; track item) {
        <div
          [ngClass]="getItemClass(item)">
          @if (item.icon) {
            <pa-hero-icon
              [name]="item.icon.name"
              [size]="item.icon.size"
              [class]="item.icon.class">
            </pa-hero-icon>
          }
          <editable-item [estimate]="estimate"
            [item]="item"
            [estimateChange]="estimateChange">
          </editable-item>
        </div>
      }
    </div>
  </div>
}
